import { useHostPage } from "../hooks/use-host-page";

export const HostPage = ({ target, hook }) => {
  const { loading, url: src } = useHostPage(target, hook);

  // TODO: allow for custom loading component
  if (loading) return "...";

  // TODO: full page or auto resize?
  return <iframe src={src} width="100%" height="1310px" frameBorder="0" />;
};
